@if (showBoutton) {
  <div>
    <div class="form-group action-button">
      @for (tmpStatus of possibleStatuses; track tmpStatus) {
        <span>
          <button class="btn btn-xs" (click)="onClick(tmpStatus)">{{ 'STATUS.SERVICE.ACTIONS.' + tmpStatus | translate }}</button>
        </span>
      }
      @if (loaded) {
        <span>
          <button class="btn btn-danger btn-xs" (click)="cancel()">
            {{ 'SERVICE.STATUS.CANCEL' | translate }}
          </button>
        </span>
      }
    </div>
  </div>
}
